import React from 'react';
import { Reveal } from '../Reveal';
import { consequenceRows } from '../../data/site';
export function Consequences() {
  return <section className="bg-cream" data-id="element-54" data-mp="2i8sl9l76mpl7">
      <div className="mx-auto max-w-[1180px] px-5 py-20 sm:px-8 lg:py-28" data-id="element-55" data-mp="2ib6dznee3ppl">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:items-center lg:gap-16" data-id="element-56" data-mp="23k5wksvo0lhb">
          <div data-id="element-57" data-mp="28hftetldvzf6">
            <p className="micro-label text-[9px] text-gold-600" data-id="element-58" data-mp="1ujr85knemq9l">Consequences</p>
            <h2 className="mt-4 font-display text-[32px] font-semibold leading-[1.08] tracking-[-0.03em] text-charcoal-700 sm:text-[38px]" data-id="element-59" data-mp="1ulu74u6jbtqg">
              Move a key date. See every consequence before anything changes.
            </h2>
            <p className="mt-5 text-[15.5px] leading-relaxed text-charcoal-500" data-id="element-60" data-mp="1pkep7aznm3ca">
              Tasks are connected to opening milestones and to each other through Requires and
              Enables relationships. Preview every affected task, choose what moves, apply once - and
              undo the whole cascade if you need to.
            </p>
          </div>

          <Reveal className="overflow-hidden rounded-2xl border border-line bg-white shadow-sm" data-id="element-61" data-mp="373un0btrox6d">
            <div className="flex items-baseline justify-between gap-4 border-b border-line px-5 py-4" data-id="element-62" data-mp="324qelneo33h3">
              <p className="micro-label text-[9px] text-charcoal-400" data-id="element-63" data-mp="3gxtiwt38zkpv">Schedule impact</p>
              <p className="text-[11.5px] text-charcoal-400" data-id="element-64" data-mp="3bxfle4z9vt63">Licence granted → +9 days</p>
            </div>

            <table className="w-full text-left" data-id="element-65" data-mp="2o95voryxul9o">
              <caption className="sr-only" data-id="element-66" data-mp="2j8rzc76p8zrh">
                Tasks affected by moving the liquor licence date
              </caption>
              <thead data-id="element-67" data-mp="2x92p16w9w8b2">
                <tr className="border-b border-line" data-id="element-68" data-mp="2x5evi7qtvlwc">
                  <th scope="col" className="micro-label px-5 py-2.5 text-[8.5px] font-bold text-charcoal-300" data-id="element-69" data-mp="2t5d2so32m2t7">
                    Affected task
                  </th>
                  <th scope="col" className="micro-label px-5 py-2.5 text-right text-[8.5px] font-bold text-charcoal-300" data-id="element-70" data-mp="8fnlm4ewa4xc">
                    Movement
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-line" data-id="element-71" data-mp="3b9wlbbg66crs">
                {consequenceRows.map(row => <tr key={row.task} data-id="element-72" data-mp="3f9n9r8i84gt5">
                    <td className="px-5 py-3" data-id="element-73" data-mp="2ijwg1bhraxoe">
                      <p className="text-[13.5px] text-charcoal-700" data-id="element-74" data-mp="2il7i96vjzxde">{row.task}</p>
                      {row.crosses && <p className="mt-0.5 text-[11.5px] font-medium text-clay-600" data-id="element-75" data-mp="2nj90jpl5nsnt">
                          Crosses opening day
                        </p>}
                    </td>
                    <td className="whitespace-nowrap px-5 py-3 text-right align-top text-[13px] font-medium tabular-nums text-charcoal-500" data-id="element-76" data-mp="2wdfdgu76vg9z">
                      {row.movement}
                    </td>
                  </tr>)}
              </tbody>
            </table>

            <p className="border-t border-line px-5 py-4 text-[12px] text-charcoal-400" data-id="element-77" data-mp="1wapopk1wz5il">
              3 of 5 affected tasks would cross opening. Add an exception, or replan.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}